<template>
    <div class="app-container first_draft_box">
        <div class="first-draft">
            <div class="article-box">
                <div class="article-picture" v-if="draftDataObj.evaluation">
                    <el-image style="width: 150px; height: 120px" :src="draftDataObj.evaluation.cover_img_vertical"
                        fit="cover" :preview-src-list="[draftDataObj.evaluation.cover_img_vertical]"></el-image>
                </div>
                <img style="width: 30px; height: 30px;margin: 0 10px" v-if="platform.path" :src="platform.path" fit="cover" />
                <p class="article-name" v-if="draftDataObj.evaluation">{{ draftDataObj.evaluation.name }}</p>
            </div>

            <div class="first-draft-item"
                :class="draftDataObj.new_first_draft_content.length - 1 !== index ? 'border-b' : ''"
                v-for="draftData, index in draftDataObj.new_first_draft_content" :key="index">
                <div class="draft-title">
                    <div style="display: flex;align-items:center;justify-content:space-between;">
                        <h3>标题</h3>
                        <div style="color:#999;">{{ draftData.first_submit_at }}</div>
                    </div>
                    <div
                        style="width: 450px;padding: 0px 20px;line-height: 25px;text-align: justify;letter-spacing: 0.1em;">
                        {{ draftData.first_draft_title }}</div>
                </div>
                <div class="draft-content">
                    <h3>测评内容</h3>
                    <div
                        style="width: 450px;padding: 0px 20px;line-height: 25px;text-align: justify;letter-spacing: 0.1em;">
                        {{ draftData.first_draft_content }}
                    </div>
                </div>
                <div class="draft-media">
                    <h3>测评图片/视频</h3>
                    <div class="media-box" style="padding: 0px 20px;">
                        <div class="video-box" v-for="mediaItem, i1 in draftData.videoList" :key="i1"
                            @click="onPlayVideo(mediaItem)">
                            <video style="display: block; width: 150px; height: 150px;" :src="mediaItem" muted></video>
                            <i class="play-icon el-icon-video-play"></i>
                        </div>
                        <el-image
                            style="width: 150px; height: 150px; margin: 5px; border: 1px dashed #d1e9ff; border-radius: 3px;"
                            v-for="mediaItem, i2 in draftData.pictureList" :key="i2" :src="mediaItem" fit="cover"
                            :preview-src-list="draftData.pictureList"></el-image>
                    </div>
                </div>
                <div class="reject" v-if="(draftData.state === 4 || draftData.state === 5) &&
                    draftData.first_draft_reject
                    ">
                    <h3>驳回原因</h3>
                    <div class="reject-content" v-html="draftData.first_draft_reject"></div>
                </div>
            </div>



            <div class="option-box">
                <el-button @click="backHandler">返回</el-button>
                <template v-if="draftDataObj.state === 4">
                    <el-button type="warning" @click="rejectModal = true">驳回</el-button>
                    <el-button type="primary" :loading="submitting" @click="onFirstDraftPass">通过</el-button>
                </template>
            </div>

            <el-dialog :title="modelTitle" :visible.sync="rejectModal" :close-on-click-modal="false"
                :destroy-on-close="true" append-to-body width="780px">
                <span slot="title" class="custom-dialog-title" style="font-size: 25px;">{{modelTitle}}</span>
                <el-form ref="rejectForm" :model="form">
                    <template v-if="isRejectFlag">
                        <h3>驳回理由</h3>
                        <el-form-item prop="reject" style="margin-left: 20px;"
                            :rules="{ required: true, message: '请输入驳回理由', trigger: 'blur' }">
                            <el-input type="textarea" :rows="4" placeholder="请输入驳回理由" v-model="form.reject"
                                style="width: 90%;" />
                            <!-- <tinymce style="width:100;" :height="500" v-model="form.reject" ref="tinymce" /> -->
                        </el-form-item>
                        <h3>内容</h3>
                        <el-form-item prop="reject_content" style="margin-left: 20px;"
                            :rules="{ required: true, message: '请输入初稿参考内容', trigger: 'blur' }">
                            <el-input type="textarea" :rows="4" placeholder="请输入初稿参考内容" v-model="form.reject_content"
                                style="width: 90%;" />
                        </el-form-item>

                        <h3 style="margin-top: 50px;">视频/图片</h3>
                        <el-form-item prop="reject_url"
                            :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
                            <upload-list :list="form.reject_url" width="150px" height="150px"></upload-list>
                        </el-form-item>

                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>
                                <el-button @click="rejectModal = false">取消</el-button>
                                <el-button type="primary" :loading="submitting"
                                    @click="onReject('rejectForm')">确认</el-button>
                            </div>

                            <el-button :loading="submitting" @click="checkTypeHandler('rejectForm')">修改并提交初稿</el-button>

                        </div>
                    </template>

                    <template v-else>
                        <h3>标题</h3>
                        <el-form-item prop="first_draft_title" style="margin-left: 20px;"
                            :rules="{ required: true, message: '请输入标题', trigger: 'blur' }">
                            <el-input placeholder="请输入标题" v-model="form.first_draft_title" style="width: 300px;" />
                        </el-form-item>
                        <h3>内容</h3>
                        <el-form-item prop="first_draft_content" style="margin-left: 20px;"
                            :rules="{ required: true, message: '请输入初稿参考内容', trigger: 'blur' }">
                            <el-input type="textarea" :rows="4" placeholder="请输入初稿参考内容" v-model="form.first_draft_content"
                                style="width: 90%;" />
                        </el-form-item>

                        <h3 style="margin-top: 50px;">视频/图片</h3>
                        <el-form-item prop="first_draft_url"
                            :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
                            <upload-list :list="form.first_draft_url" width="150px" height="150px"></upload-list>
                        </el-form-item>

                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>
                                <el-button @click="rejectModal = false">取消</el-button>
                                <el-button type="primary" :loading="submitting"
                                    @click="submitFirst('rejectForm')">确认</el-button>
                            </div>

                            <el-button :loading="submitting" @click="checkTypeHandler('rejectForm')">驳回初稿</el-button>

                        </div>
                    </template>


                </el-form>
            </el-dialog>
            <el-dialog title="视频播放" v-if="videoVisible" :visible.sync="videoVisible" :close-on-click-modal="false"
                :destroy-on-close="true" width="60%" append-to-body>
                <video width="100%" height="550px" :src="videoUrl" autoplay controls></video>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>
import UploadList from "@/components/UploadList/index.vue";
import Tinymce from "@/components/Tinymce";
import { zhongcao } from "@/api/order";
import { checkPlatform } from '@/utils/common'

export default {
    data() {
        return {
            isRejectFlag: true,
            rejectModal: false,
            videoVisible: false,
            videoUrl: null,
            videoType: ['mp4', 'rmvb', 'wmv', 'avi', 'mov', 'flv'],
            form: {
                order_id: null,
                type: 1,
                reject: null,
                reject_content: null,
                reject_url: [],

                first_draft_content: null,
                first_draft_url: [],
                first_draft_title: null,

            },
            submitting: false,

            draftDataObj: {}
        }
    },
    components: { Tinymce, UploadList },
    props: {
        id: String | Number,
        title: String,
    },
    methods: {
        checkTypeHandler(formName) {
            this.$refs[formName].resetFields();
            this.initRejectForm()
            this.isRejectFlag = !this.isRejectFlag
        },
        initRejectForm() {
            this.form.reject = null
            this.form.reject_content = ''
            this.form.reject_url = []

            this.form.first_draft_content = null
            this.form.first_draft_url = []
            this.form.first_draft_title = ''
        },
        backHandler() {
            this.$router.back();
        },
        submitFirst(formName) {
            console.log(this.form, '提交初稿1111111111111111111')

            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let first_draft_url = this.form.first_draft_url.map((item) => {
                        return {
                            path: item,
                            type: this.videoType.indexOf(item.substring(item.lastIndexOf('.') + 1)) == -1 ? 1 : 2
                        }
                    })
                    this.form.type = 3;
                    try {
                        this.submitting = true;
                        await zhongcao.firstDraftReview({ ...this.form,first_draft_url });
                        this.$message({
                            message: "已提交初稿!",
                            type: "success",
                        });
                        this.rejectModal = false
                        this.init()
                    } catch {
                        this.$message.error("出错了!");
                    } finally {
                        this.submitting = false;
                    }
                }
            });
        },
        onReject(formName) {
            console.log(this.form, '驳回1111111111111111111')

            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let reject_url = this.form.reject_url.map((item) => {
                        return {
                            path: item,
                            type: this.videoType.indexOf(item.substring(item.lastIndexOf('.') + 1)) == -1 ? 1 : 2
                        }
                    })
                    this.form.type = 2;
                    try {
                        this.submitting = true;
                        await zhongcao.firstDraftReview({ ...this.form, reject_url });
                        this.$message({
                            message: "已驳回初稿!",
                            type: "success",
                        });
                        this.rejectModal = false
                        this.init()
                    } catch {
                        this.$message.error("出错了!");
                    } finally {
                        this.submitting = false;
                    }
                }
            });
        },
        onPlayVideo(url) {
            this.videoUrl = url;
            this.videoVisible = true;
        },
        onFirstDraftPass() {
            this.$confirm("此操作将通过审核, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(async () => {
                    this.form.type = 1;
                    try {
                        await zhongcao.firstDraftReview({ ...this.form });
                        this.$message({
                            type: "success",
                            message: "已通过审核!",
                        });
                        this.init()
                        // this.$router.back();
                    } catch {
                        this.$message.error("出错啦!");
                    }
                })
                .catch(() => {
                    this.$message("审核取消!");
                });
        },
        async init() {
            const { data } = await zhongcao.details(this.id)
            // data.videoList
            if (data.new_first_draft_content && data.new_first_draft_content.length > 0) {
                data.new_first_draft_content.forEach(contentItem => {
                    contentItem.pictureList = []
                    contentItem.videoList = []
                    if (contentItem.first_draft_url && contentItem.first_draft_url.length > 0) {
                        contentItem.first_draft_url.forEach((item) => {
                            if (item.type == 1) {
                                // this.pictureList.push(item.path);
                                contentItem.pictureList.push(item.path)
                            } else if (item.type == 2) {
                                // this.videoList.push(item.path);
                                contentItem.videoList.push(item.path)
                            }
                        });
                    }
                });

            }
            this.draftDataObj = data
            this.form.order_id = this.id
            console.log(this.draftDataObj)
            console.log(11111111111111111111111)
        },
        checkPlatform,

    },
    computed: {
        modelTitle() {
            return this.isRejectFlag ? '驳回' : '修改并提交初稿'
        },
        platform() {
            return this.checkPlatform(this.draftDataObj.channel_id)
        }
    },
    // watch: {
    //     show(val) {
    //         if (val) {
    //             this.form.order_id = this.draftData.order_id
    //         }
    //     }
    // },
    created() {
        // console.log('---------------------', this.$route.params)
        // // this.draftData = this.$route.params
        // console.log('---------------------', this.draftData)
        // this.form.order_id = this.draftData.order_id;
        // if (this.draftData.first_draft_url && this.draftData.first_draft_url.length > 0) {
        //     this.draftData.first_draft_url.map((item) => {
        //         if (item.type === 1) {
        //             this.pictureList.push(item.path);
        //         } else if (item.type === 2) {
        //             this.videoList.push(item.path);
        //         }
        //     });
        // }
        this.init()
    },
};
</script>
  
<style lang="scss" scoped>
.first_draft_box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.first-draft {
    width: 30%;
    min-width: 700px;

    .first-draft-item {
        padding-bottom: 30px;
    }
}

.border-b {
    border-bottom: 1px solid #ccc;
}

.media-box {
    margin: -5px;

    .video-box {
        position: relative;
        display: inline-block;
        width: 150px;
        height: 150px;
        margin: 5px;
        border: 1px dashed #d1e9ff;
        border-radius: 3px;
        cursor: pointer;

        .play-icon {
            font-size: 3rem;
            color: white;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.article-box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 25px;

    .article-name {
        font-size: 1rem;
        margin: 0;
        margin-left: 0px;
        margin-top: 5px;
    }
}

.reject-content {
    overflow: hidden;

    &>p:first-child,
    &>p:last-child {
        margin: 0;
    }

    img {
        width: 100%;
        height: auto;
    }
}

.option-box {
    margin: 18px 0 20px 0;
}
</style>
  